











import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Prop} from "vue-property-decorator";
import vClickOutside from "v-click-outside";

@Component({
    name: "EditableCell",
    directives: {clickOutside: vClickOutside.directive}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: String, default: 'on'}) readonly mode: string | undefined;

    editable = false;

    check() {
        this.editable = false;
    }
    edit() {
        if (this.mode == 'off') return;

        this.editable = true;
    }

    // mounted() {
    //     this.$on('blur', () => {console.log('ccc'); this.check()});
    // }
}
